import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, throwError } from 'rxjs';

export const billingUpgradeInterceptorFn: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toast = inject(ToastService);
  const transloco = inject(TranslocoService);

  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse) {
        const status = error.status;
        const upgradeRequired = error.error?.upgradeRequired;

        if ((status === 402 || status === 403) && upgradeRequired) {
          const msg = toast.mapBackendError(error);
          toast.show(msg, 'error');

          // Avoid redirect loop if already on billing page
          if (!req.url.includes('/billing')) {
            router.navigate(['/billing']);
          }
        }
      }
      return throwError(() => error);
    })
  );
};
